module.exports = __webpack_public_path__ + "static/media/p2_17.40212c9c.png";